import React, { forwardRef } from 'react';
import {
  default as MuiPopper,
  PopperProps as MuiPopperProps,
  PopperPlacementType as MuiPopperPlacementType
} from '@mui/material/Popper';
import { BpDesignSystem } from '../../types';

export type PopperProps = BpDesignSystem.PropsWithChildren<MuiPopperProps & {}>;

export type PopperPlacementType = MuiPopperPlacementType;

export const Popper = forwardRef<HTMLDivElement, PopperProps>(({ dataTest, ...props }, ref) => (
  <MuiPopper ref={ref} data-test={dataTest} {...props} />
));
